export function initBudgetSliders(form) {
    const budgetInputContainers = form.querySelectorAll('.freeform-column[data-budget-input]');

    budgetInputContainers.forEach(budgetInputContainer => {
        const budgetInput = budgetInputContainer.querySelector('input');
        const minBudget = parseInt(budgetInput.closest('form').getAttribute('data-budget-min'), 10) || 5000;
        const maxBudget = parseInt(budgetInput.closest('form').getAttribute('data-budget-max'), 10) || 50000;
        const defaultMinBudget = minBudget + (maxBudget - minBudget) * 0.1;
        const defaultMaxBudget = minBudget + (maxBudget - minBudget) * 0.3;

        // Calculate slider value
        const calculateSliderValue = (value) => {
            return Math.round(minBudget + (value / 100) * (maxBudget - minBudget));
        };

        const formatCurrency = (value) => {
            if (value >= 1000) {
                const formattedValue = (value / 1000).toFixed(0);
                // Check if the value equals maxBudget, if so, add a plus sign
                const suffix = value === maxBudget ? 'k+' : 'k';
                return `$${formattedValue}${suffix}`;
            } else {
                return `$${new Intl.NumberFormat('en-AU', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }).format(value)}`;
            }
        };

        // Slider template
        const budgetSliderTemplate = document.createElement('div');
        budgetSliderTemplate.className = 'budget-input-slider-container';
        budgetSliderTemplate.innerHTML = `
            <div class="budget-slider">
                <span class="budget-min">
                    ${formatCurrency(minBudget)}
                </span>
                <div class="slider-wrapper">
                    <div class="slider-range">
                        <input type="range" class="slider-min" min="0" max="100" value="0">
                        <input type="range" class="slider-max" min="0" max="100" value="100">
                        <div class="slider-track"></div>
                    </div>
                </div>
                <span class="budget-max">
                    ${formatCurrency(maxBudget)}
                </span>
            </div>

            <div class="slider-values">
                <span class="slider-value"></span>
            </div>
        `;

        // Append the slider to the container
        budgetInputContainer.append(budgetSliderTemplate);

        const budgetSliderMin = budgetSliderTemplate.querySelector('.slider-min');
        const budgetSliderMax = budgetSliderTemplate.querySelector('.slider-max');
        const sliderTrack = budgetSliderTemplate.querySelector('.slider-track');
        const sliderValue = budgetSliderTemplate.querySelector('.slider-value');

        // Update the slider track colour range
        const updateSliderTrack = () => {
            // Get the current min and max percentage values
            const minPercentage = Math.min(budgetSliderMin.value, budgetSliderMax.value);
            const maxPercentage = Math.max(budgetSliderMin.value, budgetSliderMax.value);
            const percentageDifference = maxPercentage - minPercentage;
            const thumbSize = 24; // slider thumb size in px

            // Set the track's left position and width
            sliderTrack.style.left = `calc(${minPercentage}% - ${(minPercentage / 100) * thumbSize}px)`;
            sliderTrack.style.width = `calc(${percentageDifference}% + ${((100 - percentageDifference) / 100) * thumbSize}px)`;
        };

        // Set initial values
        budgetSliderMin.value = ((defaultMinBudget - minBudget) / (maxBudget - minBudget)) * 100;
        budgetSliderMax.value = ((defaultMaxBudget - minBudget) / (maxBudget - minBudget)) * 100;

        if (budgetSliderMin.value !== budgetSliderMax.value) {
            sliderValue.textContent = formatCurrency(calculateSliderValue(budgetSliderMin.value)) + ' - ' + formatCurrency(calculateSliderValue(budgetSliderMax.value));
            budgetInput.setAttribute('value', `Min. ${formatCurrency(calculateSliderValue(budgetSliderMin.value))} to Max. ${formatCurrency(calculateSliderValue(budgetSliderMax.value))}`);
        } else {
            sliderValue.textContent = formatCurrency(calculateSliderValue(budgetSliderMin.value));
            budgetInput.setAttribute('value', `${formatCurrency(calculateSliderValue(budgetSliderMin.value))}`);
        }

        updateSliderTrack();

        // Event listener for slider change
        const updateSliderValues = () => {
            const minValue = Math.min(budgetSliderMin.value, budgetSliderMax.value);
            const maxValue = Math.max(budgetSliderMin.value, budgetSliderMax.value);

            if (minValue !== maxValue) {
                sliderValue.textContent = formatCurrency(calculateSliderValue(minValue)) + ' - ' + formatCurrency(calculateSliderValue(maxValue));
                budgetInput.setAttribute('value', `Min. ${formatCurrency(calculateSliderValue(minValue))} to Max. ${formatCurrency(calculateSliderValue(maxValue))}`);
            } else {
                sliderValue.textContent = formatCurrency(calculateSliderValue(minValue));
                budgetInput.setAttribute('value', `${formatCurrency(calculateSliderValue(minValue))}`);
            }

            updateSliderTrack();
        };

        budgetSliderMin.addEventListener('input', updateSliderValues);
        budgetSliderMax.addEventListener('input', updateSliderValues);

        // Dragging the colored range (support for both mouse and touch)
        let isDragging = false;
        let dragOffsetX = 0;
        let initialMinValue, initialMaxValue;

        const startDrag = (e) => {
            e.preventDefault();
            isDragging = true;
            dragOffsetX = (e.clientX || e.touches[0].clientX);
            initialMinValue = parseFloat(budgetSliderMin.value);
            initialMaxValue = parseFloat(budgetSliderMax.value);
            document.body.style.userSelect = 'none'; // Disable text selection during drag
        };

        const onDrag = (e) => {
            if (!isDragging) return;

            const clientX = e.clientX || (e.touches && e.touches[0].clientX);
            if (!clientX) return;

            const delta = ((clientX - dragOffsetX) / sliderTrack.parentElement.getBoundingClientRect().width) * 100;

            let newMinValue = initialMinValue + delta;
            let newMaxValue = initialMaxValue + delta;

            if (newMinValue < 0) {
                newMaxValue -= newMinValue;
                newMinValue = 0;
            }
            if (newMaxValue > 100) {
                newMinValue -= (newMaxValue - 100);
                newMaxValue = 100;
            }

            budgetSliderMin.value = newMinValue;
            budgetSliderMax.value = newMaxValue;

            updateSliderValues();
        };

        const stopDrag = () => {
            isDragging = false;
            document.body.style.userSelect = ''; // Re-enable text selection after drag
        };

        sliderTrack.addEventListener('mousedown', startDrag);
        sliderTrack.addEventListener('touchstart', startDrag);
        window.addEventListener('mousemove', onDrag);
        window.addEventListener('touchmove', onDrag);
        window.addEventListener('mouseup', stopDrag);
        window.addEventListener('touchend', stopDrag);
        window.addEventListener('touchcancel', stopDrag);
    });
}
